import React from "react"
import { getAlgoliaResults } from "@algolia/autocomplete-js"
import algoliasearch from "algoliasearch"
import { Autocomplete } from "./Autocomplete"
import { PostPreview } from "./PostPreview"

const searchClient = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY
)
const SearchBar = () => {
  return (
    <div className="app-container w-full md:w-2/4 lg:w-2/3 mt-2 md:mt-0">
      <Autocomplete
        openOnFocus={false}
        getSources={({ query }) => [
          {
            sourceId: "",
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: "Blog",
                    query,
                  },
                ],
              })
            },
            templates: {
              noResults() {
                return "Non ci sono risultati di ricerca."
              },
              item({ item, components }) {
                return <PostPreview hit={item} components={components} />
              },
            },
          },
        ]}
      />
    </div>
  )
}

export default SearchBar
